var _defs, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 90,
    clipPath: "url(#clip)",
    dominantBaseline: "middle",
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 52,
    textLength: 140,
    lengthAdjust: "spacingAndGlyphs",
    fill: "#009FE3"
  }, "SAP")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSap);
export default __webpack_public_path__ + "static/media/sap.8163bc1d54cb2e19c3e311bc48ed7d26.svg";
export { ForwardRef as ReactComponent };